import 'reflect-metadata';
import '../polyfills';
import './core/collection-utils'
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { DatePipe, HashLocationStrategy, LocationStrategy } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { CoreModule } from './core/core.module';
import { SharedModule } from './shared/shared.module';

import { TabsModule } from 'ngx-bootstrap/tabs';
import { ModalModule } from 'ngx-bootstrap/modal';

import { AppRoutingModule } from './app-routing.module';

import { LoginModule } from './login/login.module';
import { HomeModule } from './home/home.module';
import { UserModule } from './user/user.module';
import { NotificationComponent } from './notification/notification.component';
import { TaskModule } from './task/task.module'
import { BuildingModule } from './building/building.module'
import { PointModule } from './point/point.module'
import { PathModule } from './path/path.module'
import { ScoutModule } from './scout/scout.module'
import { PostProcessingModule } from './post-processing/post-processing.module'
import { DialerClientModule } from './dialer-client/dialer-client.module'
import { EventLogModule } from './event-log/event-log.module'
import { AppComponent } from './app.component'

import { JwtInterceptor, ErrorInterceptor } from './core/security';
import { AppConfig } from '../environments/environment';
import { ServiceWorkerModule } from '@angular/service-worker';
import { NgPipesModule } from 'ngx-pipes';
import { Apollo } from 'apollo-angular';


@NgModule({
  declarations: [AppComponent, NotificationComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    CoreModule,
    SharedModule,
    LoginModule,
    HomeModule,
    UserModule,
    TaskModule,
    BuildingModule,
    PointModule,
    PathModule,
    ScoutModule,
    PostProcessingModule,
    AppRoutingModule,
    DialerClientModule,
    EventLogModule,
    NgPipesModule,
    TabsModule.forRoot(),
    ModalModule.forRoot(),
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: AppConfig.production && AppConfig.pwa, registrationStrategy: 'registerImmediately' })
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    DatePipe,
    Apollo,
    {provide: LocationStrategy, useClass: HashLocationStrategy}
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
